import { __getCommonData } from 'store/selectors';

const getRecommendationSettings = (state: any) => __getCommonData(state).recommendations;
const getCrossSellRecommends = (state: any) => getRecommendationSettings(state).crossSell;

export const getCrossSellData = (state: any) => getCrossSellRecommends(state).devices || [];
export const getCrossSellIsFetching = (state: any) => getCrossSellRecommends(state).isFetching;
export const getCrossSellStrategyName = (state: any) => getCrossSellRecommends(state).strategyName;
export const getCrossSellStrategyMessage = (state: any) =>
  getCrossSellRecommends(state).strategyMessage;
export const getCrossSellPlacement = (state: any) => getCrossSellRecommends(state).placement;
